var map = {
	"./zh-cn": 463,
	"./zh-cn.js": 463
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1869;


//////////////////
// WEBPACK FOOTER
// ../~/moment/locale zh-cn
// module id = 1869
// module chunks = 1